<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">View Errors</div>
        <div>
          <bread-crumb :bread-crumbs="['Error']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-form ref="logs">
          <v-row class="mt-1">
            <v-col cols="12" md="2" lg="3" xs="12">
              <v-autocomplete
                :items="Servicesarray"
                v-model="userSelectedFilter"
                item-text="name"
                item-value="id"
                :rules="ServiceRules"
                outlined
                dense
                placeholder="Service"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" lg="2" xs="12">
              <!-- <label class="font-weight-large my-0">Error ID</label> -->
              <v-text-field
                placeholder="Record ID"
                :items="errorLog"
                v-model="errorid"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" lg="2" xs="12">
              <!-- <label class="font-weight-large my-0">From</label> -->
              <v-text-field
                v-model="from_date"
                :items="errorLog"
                :max="maxDate"
                type="date"
                :rules="[validateFromDate]"
                label="From date"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" lg="2" xs="12">
              <!-- <label class="font-weight-large my-0">To</label> -->
              <v-text-field
                v-model="to_date"
                :items="errorLog"
                :rules="[validateToDate]"
                type="date"
                label="To date"
                :max="maxDate"
                dense
                outlined
              ></v-text-field>
            </v-col>

            <div class="d-flex">
              <v-btn
                depressed
                small
                class="text-capitalize"
                color="primary"
                @click="getErrorlogs()"
                >Get Results</v-btn
              >
            </div>
          </v-row>
        </v-form>
        <v-row class="mb-3">
          <v-spacer></v-spacer>
          <v-col cols="12" md="4" lg="4" xs="12"
            ><v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to search the table data."
              hide-details
              class="ms-4 me-4"
              dense
              clearable
            ></v-text-field
          ></v-col>
        </v-row>
        <v-data-table
          fixed-header
          height="55vh"
          :headers="headers"
          :items="errorLog"
          :items-per-page="10"
          dense
          loading-text="Please select the criteria to view records."
          no-data-text="Please select the criteria to view records."
        ></v-data-table>
      </v-card-text>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
// import userService from "@/services/UserService/userService.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import commonService from "@/services/CommonService/commonService.js";
import { LogsManage } from "@/utils/validationCopy.js";
export default {
  name: "Error",
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  data: () => ({
    ...LogsManage,
    headers: [
      {
        text: "Error ID",
        align: "start",
        sortable: false,
        value: "_id",
      },
      {
        text: "Api Route Uri",
        value: "api_route_uri",
        align: "start",
        width: "200",
      },
      {
        text: "Api Route Method",
        value: "api_route_method",
        align: "start",
        width: "50",
      },

      { text: "Error Desc", value: "response_body.msg", align: "center" },
      {
        text: "Function Involved ",
        value: "functions_involved",
        align: "start",
        width: "200",
      },
      { text: "Date", value: "start_timestamp", align: "center" },
      // { text: "From", value: "from_by", align: "center" },
      // { text: "Asp Desc", value: "asp_desc", align: "center" },
      // { text: "Ip", value: "ip", align: "center" },
    ],
    errorLog: [],
    Servicesarray: [],
    selectedFilterIndex: null,

    userSelectedFilter: null,
    loaderOverlay: false,
    search: "",
    errorid: null,
    from_date: null,
    to_date: null,
  }),

  computed: {
    maxDate() {
      // get current date and format as YYYY-MM-DD for use with max attribute
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      return `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
    },
  },
  mounted() {
    this.getErrorserviceValues();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async getErrorserviceValues() {
      try {
        const responseData = await commonService.getErrorserviceValues("ELOG");
        if (responseData.data.status_code === 200) {
          this.Servicesarray = responseData.data.data.map((i) => {
            return { name: i.value, id: i.value_code };
          });
        }

        console.log("getserviceValues", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getErrorlogs() {
      const validate = this.$refs.logs.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const params = {
            service: this.userSelectedFilter,
            from_date: this.from_date,
            to_date: this.to_date,
            record_id: this.errorid,
            skip: 0,
            limit: 50,
          };
          const response = await commonService.getErrorlogs(params);
          if (response.status === 200) {
            this.errorLog = response.data.DATA;
            console.log("errorLog", this.errorLog);
            this.stoploader();
          } else {
            this.errorLog == [];
            this.stoploader();
          }
        } catch (error) {
          this.errorLog = [];
          this.stoploader();
          console.error(error);
        }
      }
    },
    validateFromDate(value) {
      if (value && this.to_date) {
        return (
          value <= this.to_date || "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.from_date) {
        return (
          value >= this.from_date || "To date cannot be earlier than From date"
        );
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
</style>
